// extracted by mini-css-extract-plugin
export default {"resetButton":"SnTC401","root":"GLU_7y1","preloader":"XUoehLk"};